<div class="siteListContainer">

    <div class="header-container">
        
        <div class="header-text">
            <img src="assets/library-icons/securityCameraWhite.svg">
            Cameras
        </div>
        <div>
             <img class="close"  src="assets/library-icons/close.svg" (click)="closeSiteListContainer()">
        </div>
    </div>
    <div class="searchContainer">
       
        <form class="filter-form">
            <div class="search-wrapper">
              
                <mat-form-field appearance="outline" class="typeahead-field">
                    <mat-label class="placeholder">Search Camera</mat-label>
                    <input matInput type="text" class="placeholder" placeholder="Camera Name ..." [formControl]="searchControl" />
                    <span matSuffix class="suffix-container">
                    @if(searchControl.value){
                       
                            <mat-icon class="cancel-search" (click)="clearSearch()">close</mat-icon>
                        
                    }
                    <mat-icon  class="search-icon">search</mat-icon>
                    </span>
                </mat-form-field>
            </div>
        </form>

    </div>

    @for (cam of searchList; track cam.id) {
        <div class="list-item" (click)="onSiteSelect(cam)">
        @if(cam.selected){
            <img class="site-actions" src="assets/library-icons/remove.svg">
        }
        @else{
            <img class="site-actions" src="assets/library-icons/add.svg">
        }

            {{ cam.name }}
        </div>
    }
</div>
